// extracted by mini-css-extract-plugin
export default {"root":"DcCf_EGv4h1MV20308LS"};